import { publicAssetsURL } from '#internal/nuxt/paths';export default publicAssetsURL("/img/about/block1-高级版.png")